import { useEffect, useState } from 'react';

import LogoIcon from '../../../assets/images/Learnit_logo.svg';
import { AuthLayout } from '../../../components/common/AuthLayout';
import CompanyBanner from '../../../components/common/AuthLayout/CompanyBanner';
import { LogoButton } from '../../../components/common/buttons/LogoButton';
import LoadingOverlay from '../../../components/common/LoadingOverlay';
import { LoginForm } from '../../../components/forms/LoginForm';
import { useErrorRequestParam } from '../../../hooks/hooks';
import { ICompany } from '../../../models/ICompany';
import { getInviteDetails } from '../../../requests';

export const InviteSamlLogin = () => {
  const [loading, setLoading] = useState(true);
  const [company, setCompany] = useState<ICompany | null>(null);

  useErrorRequestParam();

  useEffect(() => {
    getInviteDetails()
      .then((response) => {
        setCompany(response.company);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <AuthLayout
      button={<LogoButton logo={LogoIcon} />}
      banner={company ? <CompanyBanner company={company} /> : null}
      hideSignUpButton={true}
    >
      {loading ? (
        <LoadingOverlay text="Loading..." />
      ) : (
        <LoginForm
          setEmailSent={() => {}}
          header="SAML Log in"
          samlOnly={true}
        />
      )}
    </AuthLayout>
  );
};
